import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {
  getAllWebProjects,
  deleteWebProject,
  swapOrdersWebProject,
  changeStatusWebProjectStatus,
} from "../../../../api/webProject";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";

export default function WebProjectPage() {
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [data, setData] = useState([]);
  const [webProject, setWebProject] = useState(null);

  const [tableKey, setTableKey] = useState(0);

  function buttonFormatter(cell) {
    const currentIndex = data.findIndex((item) => item.order === cell);
    const prevId = currentIndex > 0 ? data[currentIndex - 1].order : null;
    const nextId =
      currentIndex < data.length - 1 ? data[currentIndex + 1].order : null;

    const elem = data.find((item) => item.order === cell);
    const elemPrev = data.find((item) => item.order === prevId);
    const elemNext = data.find((item) => item.order === nextId);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-webProject/" + elem._id)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === "admin" && (
          <>
            <Tooltip title={elem?.active ? "Deactivate" : "Activate"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setWebProject(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setWebProject(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
        {prevId !== null && prevId !== undefined && (
          <Tooltip title="Move Up">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={() => {
                swapOrdersWebProject(elem._id, elemPrev._id).then((res) => {
                  const changedData = [...data];

                  const from = data.findIndex((item) => item._id === elem._id);
                  const to = data.findIndex(
                    (item) => item._id === elemPrev._id,
                  );
                  const temp = changedData[from];
                  changedData[from] = changedData[to];
                  changedData[to] = temp;

                  setData(changedData);
                  setTableKey((k) => k + 1);
                });
              }}
            >
              <ArrowUpward />
            </Button>
          </Tooltip>
        )}
        {nextId !== null && nextId !== undefined && (
          <Tooltip title="Move Down">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={() => {
                swapOrdersWebProject(elem._id, elemNext._id).then((res) => {
                  const changedData = [...data];
                  const from = data.findIndex((item) => item._id === elem._id);
                  const to = data.findIndex(
                    (item) => item._id === elemNext._id,
                  );
                  const temp = changedData[from];
                  changedData[from] = changedData[to];
                  changedData[to] = temp;
                  setData(changedData);
                  setTableKey((k) => k + 1);
                });
              }}
            >
              <ArrowDownward />
            </Button>
          </Tooltip>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "title", text: "Title", sort: false },
    { dataField: "location", text: "Location", sort: false },
    { dataField: "status", text: "status", sort: false },
    { dataField: "sizeMW", text: "Size Mw", sort: false },
    {
      dataField: "createdAt",
      text: "Fecha de creación",
      formatter: dateFormatter,
      sort: false,
    },
    {
      dataField: "order",
      text: "",
      formatter: buttonFormatter,
      headerStyle: { width: "250px" },
    },
  ];

  useEffect(() => {
    getAllWebProjects()
      .then((res) => {
        setData(res.data);
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get web projects",
        });
      });
  }, [refresh]);

  return (
    <>
      <Card>
        <CardHeader title="Web projects list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary text-white"
              onClick={() => history.push("/edit-webProject")}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Table
            search={true}
            data={data}
            columns={columns}
            key={tableKey}
            defaultSorted={[{ dataField: "order", order: "asc" }]}
          />

          <ConfirmDialog
            title={`Are you sure you want to ${
              webProject?.active ? "deactivate" : "activate"
            } this web project?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusWebProjectStatus(webProject._id, !webProject?.active)
                .then((res) => {
                  const newStatus = !webProject.active;
                  alertSuccess({
                    title: `${
                      webProject?.active ? "Deactivate!" : "Activate!"
                    }`,
                    customMessage: `Web project ${
                      webProject?.active ? "deactivate" : "activate"
                    } successfully`,
                  });

                  setData((prev) =>
                    prev.map((p) =>
                      p._id === webProject._id
                        ? { ...p, active: newStatus }
                        : p,
                    ),
                  );
                  setRefresh(true);
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      webProject?.active ? "deactivate" : "activate"
                    } the web project.`,
                  });
                });
            }}
          />

          <ConfirmDialog
            title={"Are you sure you want to delete this web project?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteWebProject(webProject._id)
                .then((res) => {
                  alertSuccess({
                    title: "Deleted!",
                    customMessage: "Web project deleted successfully.",
                  });
                  setData((prev) =>
                    prev.filter((item) => item._id !== webProject._id),
                  );
                  setRefresh(true);
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not delete the web project.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
